import { useEffect, useState } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { Box, TextField, IconButton, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

import { ISearch } from '../../../../interfaces/search.interface'

const SearchBar = ({ onSearchValueChange }: ISearch) => {
  const [search, setSearch] = useState<string>('')

  useEffect(() => {
    onSearchValueChange(search)
  }, [search])

  return (
    <Box>
      <DebounceInput
        element={TextField}
        size='small'
        label='Search...'
        sx={{ width: { md: '20rem', xs: '100%' } }}
        minLength={2}
        debounceTimeout={500}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton color='primary'>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChange={(event) => setSearch(event.target.value)}
      />
    </Box>
  )
}

export default SearchBar
